var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-start ga-2"},_vm._l((_vm.predefinedColorGroups),function(group,index){return _c('color-swatch',{key:group.base + '-' + index,style:(`color: ${group.base}`),attrs:{"color":group.base,"active":_vm.compareColorGroups(group)},nativeOn:{"click":function($event){return _vm.changeColorsTheme(group)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }